import React, {
  useEffect,
  useState,
  forwardRef,
  PropsWithoutRef,
  ComponentType,
  ForwardedRef,
} from 'react';
import { ChevronDown16 } from 'ui/icons';
import { ALIGNMENT, BasicFilterSelect, SelectValueDisplayProps, SelectValueType } from 'ui/selects';
import { useDynamicHeatmapContext } from '../../context';
import { DropdownButton } from './TemplatePreview.styles';

const parseUserList = (users: any[] = []) => {
  return users.map((user) => ({
    id: user,
    label: user,
    value: user,
  }));
};

const Trig = () =>
  forwardRef(function InnerSelectValue<TValue extends SelectValueType = string>(
    {
      isDisabled = false,
      isOpen = false,
      ...props
    }: PropsWithoutRef<Omit<SelectValueDisplayProps<TValue>, 'content'>>,
    ref: ForwardedRef<HTMLButtonElement>,
  ) {
    return (
      <DropdownButton
        ref={ref}
        $isFirst={false}
        data-test="basic-select-trigger"
        aria-disabled={isDisabled}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        type="button"
        {...props}
      >
        <ChevronDown16 />
      </DropdownButton>
    );
  });

export const UserSearch = ({ isEmbedded }: { isEmbedded?: boolean }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { userId, loadUser, userList, userCount, setUserPage, userPage } =
    useDynamicHeatmapContext();
  const [userSearchList, setUserSearchList] = useState(userList);

  useEffect(() => {
    setUserSearchList(
      userList.reduce((acc, curr) => {
        if (curr?.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
          acc.push(curr);
        }
        return acc;
      }, []),
    );
  }, [searchTerm, userList]);

  return (
    <BasicFilterSelect
      inputContent={{ filterPlaceholder: 'Search users' }}
      canFetch={!searchTerm && userList.length < userCount}
      onFetch={() => setUserPage(userPage + 1)}
      defaultValues={[userId]}
      disableInternalFiltering
      onSelect={(el) => {
        if ((el as string[])[0] !== userId) {
          loadUser((el as string[])[0]);
        }
      }}
      onSearchChange={(searchedItem: string | undefined) => setSearchTerm(searchedItem ?? '')}
      options={parseUserList(userSearchList)}
      Trigger={
        isEmbedded
          ? (Trig() as ComponentType<React.PropsWithChildren<SelectValueDisplayProps>>)
          : undefined
      }
      horizontalAlignment={isEmbedded ? ALIGNMENT.RIGHT : ALIGNMENT.LEFT}
      isFullWidth={!isEmbedded}
    />
  );
};
